import { render, staticRenderFns } from "./DatabaseItemList.vue?vue&type=template&id=df5fecfc&"
import script from "./DatabaseItemList.vue?vue&type=script&lang=js&"
export * from "./DatabaseItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports